import {translate} from '@/i18n';

const common = [
    // {
    //   path: "/workshops",
    //   name: "/workshops",
    //   component: () => import("@/views/WorkshopsPage.vue"),
    //   props: (route) => ({
    //     page: parseInt(route.query.page) || 1,
    //     nameMask: route.query.nameMask || null,
    //     fromAge: route.query.fromAge || null,
    //     toAge: route.query.toAge || null,
    //     forWithDisabilities: route.query.forWithDisabilities || -1,
    //     dateTo: route.query.dateTo || null,
    //     dateFrom: route.query.dateFrom || null,
    //     countryIso: route.query.countryIso || null,
    //   }),
    //   meta: { requiresAuth: false, layout: "Main", title: "Classes" },
    // },
    {
        path: '/classes/:officeCode?',
        name: '/classes',
        component: () => import('@/views/WorkshopsPage.vue'),
        // component: () => import('@/views/WorkshopsPageOld.vue'),
        meta: {
            requiresAuth: false,
            availableInIframe: true,
            layout: 'Main',
            title: 'Classes',
        },
    },
    {
        path: '/programs',
        name: '/programs',
        component: () => import('@/views/ProgramsPage.vue'),
        meta: {
            requiresAuth: false,
            availableInIframe: true,
            layout: 'Main',
            title: 'Programs',
        },
    },
    {
        path: '/contacts',
        name: '/contacts',
        props: () => ({
            data: {
                email: 'info@kidscrafts.shop',
            },
        }),
        component: () => import('@/views/ContactsWrapper.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'Contacts'},
    },
    {
        path: '/franchising',
        name: '/franchising',
        component: () => import('@/views/FranchisingPage/FranchisingPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'Franchising'},
    },
    {
        path: '/email-unsubscribe',
        name: '/email-unsubscribe',
        component: () => import('@/views/EmailUnsubscribePage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'PocketHeader',
            title: 'Email unsubscribe',
        },
    },
    {
        path: '/investment-deck',
        name: '/investment-deck',
        component: () => import('@/views/InvestmentDeckPage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'Main',
            title: 'Investment Deck',
        },
    },
    {
        path: '/how-it-works',
        name: '/how-it-works',
        component: () => import('@/views/HowItWorksPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'How it works'},
    },
    {
        path: '/how-it-works-2',
        name: '/how-it-works-2',
        redirect: {name: '/how-it-works'},
    },
    {
        path: '/for-schools',
        name: '/for-schools',
        component: () => import('@/views/ForSchoolsPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'For Schools & SDs'},
    },
    {
        path: '/for-families',
        name: '/for-families',
        component: () => import('@/views/ForFamiliesPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'For Families'},
    },
    {
        path: '/for-providers',
        name: '/for-providers',
        component: () => import('@/views/ForProvidersPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'For Providers'},
    },
    {
        path: '/sell-on-kids-crafts',
        name: '/sell-on-kids-crafts',
        component: () => import('@/views/SellOnKidsCraftPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'Sell On KidsCrafts'},
    },
    {
        path: '/about',
        name: '/about',
        props: () => ({
            aboutText: translate('about.text'),
            aboutMissionContent: translate('about.mission.content'),
            showAboutSlider: true,
            showContactUsBlock: true,
            aboutSliderBenefits: [
                {
                    title: 'home-page.benefits.students.title',
                    image: 'point1.png',
                    points: [
                        'home-page.benefits.students.point1',
                        'home-page.benefits.students.point2',
                        'home-page.benefits.students.point3',
                        'home-page.benefits.students.point4',
                    ],
                },
                {
                    title: 'home-page.benefits.schools.title',
                    image: 'point2.png',
                    isLeftImage: true,
                    points: [
                        'home-page.benefits.schools.point1',
                        'home-page.benefits.schools.point2',
                        'home-page.benefits.schools.point3',
                        'home-page.benefits.schools.point4',
                    ],
                },
                {
                    title: 'home-page.benefits.parents.title',
                    image: 'point3.png',
                    points: [
                        'home-page.benefits.parents.point1',
                        'home-page.benefits.parents.point2',
                        'home-page.benefits.parents.point3',
                        'home-page.benefits.parents.point4',
                    ],
                },
            ].map(({title, image, points}) => ({
                title: translate(title),
                image,
                points: points.map((point) => translate(point)),
            })),
        }),
        component: () => import('@/views/AboutPage/AboutPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'About'},
    },
    {
        path: '/invite',
        name: '/invite',
        component: () => import('@/views/InvitePage.vue'),
        meta: {requiresAuth: false, layout: 'LoginPage', title: 'Create account'},
    },
    {
        path: '/district/:districtCode',
        name: '/district',
        component: () => import('@/views/DistrictPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'District'},
    },
    {
        path: '/school/:schoolCode',
        name: '/school',
        component: () => import('@/views/SchoolPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'School'},
    },
    {
        path: '/login',
        name: '/login',
        component: () => import('@/views/LoginPage.vue'),
        meta: {requiresAuth: false, layout: 'LoginPage', title: 'Login'},
    },
    {
        path: '/for-business',
        name: '/for-business',
        component: () => import('@/views/BusinessPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'For Business'},
    },
    {
        path: '/for-investors',
        name: '/for-investors',
        component: () => import('@/views/InvestorsPage.vue'),
        meta: {requiresAuth: false, layout: 'Main', title: 'For Investors'},
    },
];

export {common};
